import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/i18n/datepicker-fr';

let date = $(".js-date");
if (date.length > 0) {
    date.each(function() {
        let dataDate = $(this).attr("data-date");
        let dates = dataDate ? JSON.parse(dataDate) : [];
        let calendarField = $(this).find(".calendar");
        let datePickerOptions = {};

        if (dates.length > 0) {
            datePickerOptions = {
                beforeShowDay: function(date) {
                    let found = false;
                    let currentDate = new Date();

                    if (date.toDateString() === currentDate.toDateString()) {
                        return [true, ""];
                    }
            
                    if (date < currentDate) {
                        return [false, ""];
                    }
                
                    for (let i = 0; i < dates.length; i++) {
                        let From = dates[i].from.split("/");
                        let To = dates[i].to.split("/");
                        let FromDate = new Date(From[2], From[1] - 1, From[0]);
                        let ToDate = new Date(To[2], To[1] - 1, To[0]);
                
                        if (date >= FromDate && date <= ToDate) {
                            found = true;
                            return [true, ""];
                        }
                    }
                
                    if (!found) {
                        return [false, ""];
                    }
                },
                
                onSelect: function() {
                    let selectedDate = $(this).datepicker("getDate");
                    let selectedDateString = $.datepicker.formatDate("yy-mm-dd", selectedDate);
                    let selectedDatePlaceholder = $.datepicker.formatDate("dd.mm.yy", selectedDate);
                    let placeholder = $(this).find(".js-date-placeholder");
                    let placeholderLable = placeholder.attr("data-label");
                    let fromInput = $(this).siblings(".js-date-from");
                    let toInput = $(this).siblings(".js-date-to");
                    let calendarReset = $(this).siblings(".js-calendar-reset");
                    let calendarIcon = $(this).find(".js-date-icon");
                    let calendar = $(this);
                    let datePicker = $(this).find(".ui-datepicker");

                    function findClosestUnavailableEndDate(selectedDate) {
                        let closestEndDate = null;
                        for (let i = 0; i < dates.length; i++) {
                            let From = dates[i].from.split("/");
                            let To = dates[i].to.split("/");
                            let FromDate = new Date(From[2], From[1] - 1, From[0]);
                            let ToDate = new Date(To[2], To[1] - 1, To[0]);
                    
                            if (selectedDate >= FromDate && selectedDate < ToDate) {
                                closestEndDate = ToDate;
                                break;
                            }
                        }
                        return closestEndDate;
                    }

                    function setDateRange() {
                        if (!fromInput.val()) {
                            fromInput.val(selectedDateString);
                            placeholder.html(`<span>De : ${selectedDatePlaceholder}</span>`);
                            calendar.datepicker("option", "minDate", selectedDate);

                            let closestEndDate = findClosestUnavailableEndDate(selectedDate);
                            if (closestEndDate !== null) {
                                calendar.datepicker("option", "maxDate", closestEndDate);
                            }
                        } else if (!toInput.val()) {
                            toInput.val(selectedDateString);
                            placeholder.html(`${placeholder.text()} <span class="end-date">À : ${selectedDatePlaceholder} </span>`);
                            datePicker.hide();
                            calendarReset.show();
                        }
                    }

                    function resetDateRange() {
                        calendarReset.on("click", () => {
                            calendar.datepicker("option", "minDate", null);
                            calendar.datepicker("option", "maxDate", null);
                            datePicker.show();
                            fromInput.val("");
                            toInput.val("");
                            placeholder.text(placeholderLable);
                            calendarReset.hide();
                            calendarIcon.show();
                            calendar.removeClass("js-calendar-reset");
                        })
                    }    
                    setDateRange();
                    resetDateRange();
                },
            };
        }else {
            datePickerOptions = {
                onSelect: function() {
                    let selectedDate = $(this).datepicker("getDate");
                    let placeholder = $(this).find(".js-date-placeholder");
                    let selectedDatePlaceholder = $.datepicker.formatDate("dd.mm.yy", selectedDate);
                    let selectedDateString = $.datepicker.formatDate("yy-mm-dd", selectedDate);
                    let datePicker = $(this).find(".ui-datepicker");

                    placeholder.text(selectedDatePlaceholder);
                    $(this).prev().val(selectedDateString);
                    datePicker.hide();
                },
            }
        }

        calendarField.datepicker(datePickerOptions);

        let datePicker = $(this).find(".ui-datepicker");
        datePicker.hide();

        
        calendarField.on("click", function() {
            if (!$(this).hasClass("js-calendar-reset")) {
                $(this).find(".ui-datepicker").show();
            }
        });
        
        $(document).on("click", function(e) {
            if(e.target.closest(".calendar") === null && e.target.closest(".ui-datepicker") === null && e.target.closest(".ui-datepicker-header") === null) {
                datePicker.hide();
            }
        });
    });
}
